import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {Store} from '@ngrx/store';
import {WatchlistApplicationState} from '../../store/watchlist-state';
import {LocalStorageService} from '@nw/ui-core-shared/services/local-storage.service';
import {WatchListActions} from '../../store/actions/WatchListActions';
import { SortOption, SortQuery, LoadVehicleQueryParams } from '../domain';


import {Observable} from 'rxjs/Observable';

@Injectable()
export class VehicleSortService {
  private optionsList = ['year', 'make', 'model', 'mileage', 'grade', 'time', 'lane', 'activity'];

  // list of mapped sortBy criteria in classic
  // putting it here for consistency
  private mappedOptions = {
    year: 'yr',
    make: 'mk',
    model: 'mdl',
    mileage: 'od',
    grade: 'gd',
    time: 'tl',
    lane: 'ln'
  };
  private defaultSortQuery: SortQuery = { sortByValue: 'activity', isDesc: true };

  constructor( private store: Store<WatchlistApplicationState>,
               private watchListActions: WatchListActions,
               private translateService: TranslateService,
               private localStorageService: LocalStorageService) {
      this.localStorageService.setLocalObject(this.localStorageService.WL_SORT, JSON.stringify(this.defaultSortQuery));
  }


  getSortOptionData(): Observable<Array<SortOption>> {

   return this.translateService.get('componentDropdownSort.sortOptions').map((translate) => {

         const sortOptions:  Array<SortOption>  = this.optionsList.map((item) => {
           const labels = Array.from(translate[item]);
           const option: SortOption = {
             'label': labels[0].toString(),
             'labelAsce': labels[1].toString(),
             'labelDesc': labels[2].toString(),
             'sortByValue': item,
             'isDesc': false
           };
           return option;
         });
     return this.initSelectedOption(sortOptions);
   });

  }


  initSelectedOption(optionList) {
    const WL_SORT = this.localStorageService.getLocalObject(this.localStorageService.WL_SORT);
    if ( WL_SORT !== null) {
      this.defaultSortQuery = JSON.parse(WL_SORT);
    }

    const selectedItem = optionList.find(item => item['sortByValue'] === this.defaultSortQuery.sortByValue);
    selectedItem['isSelected'] = true;
    selectedItem['isDesc'] = this.defaultSortQuery.isDesc;

    return optionList;
  }

  getSortByQuery(): string {

    const secondarySortList = ['time:asc', 'year:desc', 'make:asc', 'model:asc', 'mileage:asc'];
    let secondarySort = '';

    for (const sort of secondarySortList){
      // avoid adding duplicated secondary sort
      if (sort.indexOf(this.defaultSortQuery.sortByValue) < 0) {
        secondarySort += `${sort},`;
      }
    };

    const primarySort = `${this.defaultSortQuery.sortByValue}:${(this.defaultSortQuery.isDesc) ? 'desc' : 'asc'}`;

    return `sortBy=${primarySort},${secondarySort}`;
  }

  doSort(sortQuery: SortQuery) {
    // update local storage
    this.localStorageService.setLocalObject(this.localStorageService.WL_SORT, JSON.stringify(sortQuery));
    // update defaultSortQuery obj
    this.defaultSortQuery.isDesc = sortQuery.isDesc;
    this.defaultSortQuery.sortByValue = sortQuery.sortByValue;

    // dispatch store event
    this.store.dispatch(this.watchListActions.loadWatchList());
  }

  getClassicSortBy(sortBy: string) {
    return this.mappedOptions[sortBy] || 'tl';
  }
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/shared/services/vehicle-sort.service.ts